import { useIsClient } from '~/providers/IsClientProvider';

export default useIsClient;
